// extracted by mini-css-extract-plugin
export default {"main":"Routes-module__main-zC0F"};